export function tokenAmountFromProxy(proxy) {
    return { ...proxy, amount: BigInt(proxy.amount) };
}
export function tokenAmountToProxy(tokenAmount) {
    return {
        ...tokenAmount,
        amount: tokenAmount.amount.toString()
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9rZW5BbW91bnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZW50aXRpZXMvdG9rZW5BbW91bnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0JBLE1BQU0sVUFBVSxvQkFBb0IsQ0FBQyxLQUF1QjtJQUMxRCxPQUFPLEVBQUMsR0FBRyxLQUFLLEVBQUUsTUFBTSxFQUFFLE1BQU0sQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLEVBQUMsQ0FBQTtBQUNqRCxDQUFDO0FBRUQsTUFBTSxVQUFVLGtCQUFrQixDQUFDLFdBQXdCO0lBQ3pELE9BQU87UUFDTCxHQUFHLFdBQVc7UUFDZCxNQUFNLEVBQUUsV0FBVyxDQUFDLE1BQU0sQ0FBQyxRQUFRLEVBQUU7S0FDdEMsQ0FBQTtBQUNILENBQUMifQ==